import RoyaltyFeeForm from './RoyaltyFeeForm';

export default RoyaltyFeeForm;
